import { authFetch, BASE_BACKEND_URL } from '../../auth'
import { useState, useEffect } from "react"

export function useOrderViewData(orderId) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const [order, setOrder] = useState(null)
  const [invoiceApp, setInvoiceApp] = useState(null)
  const [salesOrder, setSalesOrder] = useState(null)

  useEffect(() => {
    if (!orderId) return

    const abortController = new AbortController()
    const { signal } = abortController

    const fetchAll = async () => {
      try {
        setLoading(true)
        setError(null)

        const backendUrl = BASE_BACKEND_URL

        const orderResponse = await authFetch(
          `${backendUrl}/orders/${orderId}`,
          { signal }
        )

        if (!orderResponse) return

        if (orderResponse.status === 404) {
          setError("No se encontró el pedido")
          return
        }

        if (!orderResponse.ok) {
          throw new Error("Error cargando el pedido")
        }

        const orderData = await orderResponse.json()
        setOrder(orderData)
        if (orderData?.order_db_ref) {
          const orderRef = orderData.order_db_ref

          const [invoiceResponse, salesResponse] = await Promise.all([
            authFetch(
              `${backendUrl}/invoices_app?order_id=${orderRef}`,
              { signal }
            ),
            authFetch(
              `${backendUrl}/sales_orders/${orderRef}`,
              { signal }
            )
          ])

          if (invoiceResponse?.ok) {
            const invoiceData = await invoiceResponse.json()
            setInvoiceApp(invoiceData)
          } else {
            setInvoiceApp(null)
          }

          if (salesResponse?.ok) {
            const salesData = await salesResponse.json()
            setSalesOrder(salesData)
          } else {
            setSalesOrder(null)
          }
        }

      } catch (e) {
        if (e.name === "AbortError") {
          return
        }

        console.error(e)
        setError("Error cargando datos")
      } finally {
        setLoading(false)
      }
    }

    fetchAll()
    return () => {
      abortController.abort()
    }

  }, [orderId])

  return {
    loading,
    error,
    order,
    invoiceApp,
    salesOrder
  }
}